import { createContext } from "react";
import { MicroserviceEventContextProps } from "../types";

export const MicroserviceEventsContext = createContext<MicroserviceEventContextProps>({
    clear: () => { },
    data: [],
    error: null,
    hasMore: false,
    isFetching: false,
    isLoading: false,
    isNextPageLoading: false,
    isNewRecords: false,
    isRowLoaded: false,
    limit: 50,
    loadMore: () => { },
    newRecordsSinceCache: 0,
    page: 1,
    pagination: { page: 1, pageSize: 50, totalCount: 0, totalPages: 0 },
    setPageLimit: (v: number) => { },
    setSearchTerm: (v: string) => { },
    sort: "",
    sortTable: (property: string) => { },
    totalCount: 0,
    totalPages: 0 
});